<!-- Copyright: company code. -->
<!-- @创建人: 张心彧 -->
<!-- @创建时间: 2019-09-01 -->
<!-- @文件描述: 表格工具栏,-->
<template>
  <el-card shadow="hover" :body-style="card">
    <!-- 查询表单 -->
    <el-form :inline="true" class="ali-center">
      <slot></slot>
      <el-form-item>
        <el-button type="primary" @click="searchBtn" size="small">查询</el-button>
      </el-form-item>
    </el-form>
    <!-- 操作按钮 -->
    <div class="center">
      <el-button
        v-for="(item, index) in buttonArr"
        :key="index"
        type="primary"
        size="mini"
        :icon="item.icon"
        @click="clickBtn(item.type)"
      >{{item.text}}</el-button>
      <!-- <button
        @click.stop="clickBtn"
        v-for="(item, index) in buttonArr"
        :key="index"
        :data-type="item.type"
        type="primary"
        size="mini"
        class="toor-btn"
      >
        <i :class="item.icon" :data-type="item.type"></i>
        <span class="btn-text" :data-type="item.type">{{item.text}}</span>
      </button>-->
    </div>
  </el-card>
</template>

<!-- 备注：组件必须设置以下属性/事件 -->
<!-- :buttonArr="buttonArr" @toorBtn="toorClick" @searchBtn="searchClick" -->
<script>
export default {
  name: "TableToolbar",
  props: {
    //按钮组属性  必选属性
    buttonArr: {
      type: Array,
      default() {
        return [
          {
            icon: "el-icon-edit",
            text: "编辑",
            type: "edit"
          }
        ];
      }
    }
  },
  data() {
    return {
      card: {
        "padding-top": "5px",
        "padding-bottom": "5px",
        display: "flex",
        "flex-direction": "row",
        "justify-content": "space-between"
      }
    };
  },

  //计算属性
  computed: {},

  //方法列表
  methods: {
    clickBtn(type) {
      // let type = e.target.getAttribute("data-type");
      this.$emit("handleToolClick", type);
    },
    searchBtn() {
      this.$emit("queryTable");
    }
  }
};
</script>
 
 
<style lang="scss">
.center {
  display: flex;
  align-items: center;
}
.ali-center {
  .el-form-item {
    margin-bottom: 0px;
  }
}
.toor-btn {
  min-width: 80px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #3a8ee6;
  border: none;
  border-radius: 4px;
  color: white;
  margin-left: 10px;
  outline: none;
  .btn-text {
    margin-left: 5px;
  }
}
</style>